<div class="sidebar" data-background-color="black">
  <div class="logo">
    <a class="simple-text logo-mini">
      <div class="logo-img">
        <img src="/assets/img/angular2-logo-white.png" />
      </div>
    </a>
    <a href="https://www.creative-tim.com" class="simple-text logo-normal">
      Courier & Beyond
    </a>
  </div>

  <div class="sidebar-wrapper">
    <div class="user">
      <div class="photo">
        <img [src]="userImg" />
      </div>
      <!-- <div class="user-info">
        <a data-toggle="collapse" href="#collapseExample" class="collapsed">
          <span>
            {{ userInfo.firstname }} {{ userInfo.lastname }}
            <b class="caret"></b>
          </span>
        </a>
        <div class="collapse" id="collapseExample">
          <ul class="nav">
            <li class="nav-item">
              <a href="javascript:void(0)" class="nav-link">
                <span class="sidebar-normal">My Profile</span>
              </a>
            </li>
            <li class="nav-item">
              <a href="javascript:void(0)" class="nav-link">
                <span
                  class="sidebar-normal"
                  [routerLink]="['/administracion/users/editProfile', id]"
                  >Edit Profile</span
                >
              </a>
            </li>
            <li class="nav-item">
              <a href="javascript:void(0)" class="nav-link">
                <span class="sidebar-normal">Settings</span>
              </a>
            </li>
            <li class="nav-item">
              <a href="javascript:void(0)" class="nav-link">
                <span class="sidebar-normal" (click)="logout()">Log Out</span>
              </a>
            </li>
          </ul>
        </div>
      </div> -->
      <div class="user-info">
        <a
          href="javascript:void(0)"
          id="collapseExample-p"
          (click)="expandOrCollapseMenu('collapseExample')"
          [attr.aria-expanded]="false"
          aria-controls="collapseExample"
          class="user-dropdown-link"
        >
          <span> {{ userInfo.firstname }} {{ userInfo.lastname }} </span>
        </a>

        <div
          id="collapseExample"
          class="collapse user-dropdown-content"
          aria-labelledby="collapseExample-p"
        >
          <ul class="user-menu">
            <li>
              <a class="user-menu-link"
                ><span
                  class="user-span"
                  [routerLink]="['/administracion/users/editProfile', id]"
                  >My Profile</span
                ></a
              >
            </li>
            <li>
              <a class="user-menu-link" >
                <span class="user-span" (click)="logout()">Log Out</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div *ngIf="isMobileMenu()">
      <form class="navbar-form">
        <span class="bmd-form-group"
          ><div class="input-group no-border">
            <input
              type="text"
              value=""
              class="form-control"
              placeholder="Search..."
            />
            <button
              mat-raised-button
              type="submit"
              class="btn btn-white btn-round btn-just-icon"
            >
              <i class="material-icons">search</i>
              <div class="ripple-container"></div>
            </button></div
        ></span>
      </form>
      <!-- <ul class="nav navbar-nav nav-mobile-menu">
        <li class="nav-item">
          <a class="nav-link" href="#pablo">
            <i class="material-icons">dashboard</i>
            <p>
              <span class="d-lg-none d-md-block">Stats</span>
            </p>
          </a>
        </li>
        <li class="nav-item dropdown">
          <a
            class="nav-link"
            href="#pablo"
            id="navbarDropdownMenuLink"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="material-icons">notifications</i>
            <span class="notification">5</span>
            <p>
              <span class="d-lg-none d-md-block">Some Actions</span>
            </p>
          </a>
          <div
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="navbarDropdownMenuLink"
          >
            <a class="dropdown-item" href="#"
              >Mike John responded to your email</a
            >
            <a class="dropdown-item" href="#">You have 5 new tasks</a>
            <a class="dropdown-item" href="#">You're now friend with Andrew</a>
            <a class="dropdown-item" href="#">Another Notification</a>
            <a class="dropdown-item" href="#">Another One</a>
          </div>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#pablo">
            <i class="material-icons">person</i>
            <p>
              <span class="d-lg-none d-md-block">Account</span>
            </p>
          </a>
        </li>
      </ul> -->
    </div>
    <!-- <ul class="nav">
      <li
        routerLinkActive="active"
        *ngFor="let menuitem of menuItems"
        class="nav-item"
      >
        <!--If is a single link
        <a
          [routerLink]="[menuitem.path]"
          *ngIf="menuitem.type === 'link' && !menuitem.inMore"
          class="nav-link"
        >
          <i class="material-icons">{{ menuitem.icontype }}</i>
          <p>{{ menuitem.title }}</p>
        </a>
        <!--If it have a submenu
        <a
          data-toggle="collapse"
          href="#{{ menuitem.collapse }}"
          id="{{ menuitem.collapse }}-p"
          *ngIf="menuitem.type === 'sub' && !menuitem.inMore"
          (click)="updatePS(); expandOrCollapseMenu(menuitem.collapse)"
          class="nav-link"
        >
          <i class="material-icons">{{ menuitem.icontype }}</i>
          <p>{{ menuitem.title }}<b class="caret"></b></p>
        </a>

        <!--Display the submenu items
        <div
          id="{{ menuitem.collapse }}"
          class="collapse"
          *ngIf="menuitem.type === 'sub' && !menuitem.inMore"
        >
          <ul class="nav">
            <li
              routerLinkActive="active"
              *ngFor="let childitem of menuitem.children"
              class="nav-item"
            >
              <a
                [routerLink]="[menuitem.path, childitem.path]"
                class="nav-link"
              >
                <span class="sidebar-mini">{{ childitem.ab }}</span>
                <span class="sidebar-normal">{{ childitem.title }}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>

      <!-- 2 menu  

      <li class="nav-item">
        <a
          class="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseMore"
          aria-expanded="true"
          aria-controls="collapseMore"
        >
          <i class="material-icons">add</i>
          <!-- <i class="fas fa-fw fa-cog"></i> 
          <!-- <span>More</span> 
          <p>More<b class="caret"></b></p>
        </a>
        <div id="collapseMore" class="collapse" aria-labelledby="headingMore">
          <ul class="nav">
            <li
              class="nav-item"
              *ngFor="let menuitem of menuItems"
              routerLinkActive="active"
            >
              <!-- Enlace directo 
              <a
                *ngIf="menuitem.type === 'link' && menuitem.inMore"
                [routerLink]="[menuitem.path]"
                class="nav-link"
              >
                <i class="material-icons">{{ menuitem.icontype }}</i>
                <p>{{ menuitem.title }}</p>
              </a>

              <!-- Submenú 
              <a
                *ngIf="menuitem.type === 'sub' && menuitem.inMore"
                class="nav-link"
                data-toggle="collapse"
                href="#{{ menuitem.collapse }}"
                (click)="updatePS(); expandOrCollapseMenu(menuitem.collapse)"
              >
                <i class="material-icons">{{ menuitem.icontype }}</i>
                <p>{{ menuitem.title }} <b class="caret"></b></p>
              </a>
              <div
                *ngIf="menuitem.type === 'sub' && menuitem.inMore"
                id="{{ menuitem.collapse }}"
                class="collapse"
              >
                <ul class="nav">
                  <li
                    class="nav-item"
                    *ngFor="let childitem of menuitem.children"
                    routerLinkActive="active"
                  >
                    <a
                      [routerLink]="[menuitem.path, childitem.path]"
                      class="nav-link"
                    >
                      <span class="sidebar-mini">{{ childitem.ab }}</span>
                      <span class="sidebar-normal">{{ childitem.title }}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </li>

      <!-- <li class="nav-item">
                    <a href="http://md-pro-angular.creative-tim.com/documentation/tutorial?ref=md-pro-archive" class="nav-link">
                        <i class="material-icons">school</i>
                        <p>Documentation</p>
                    </a>
                </li> 
      <li></li>
    </ul> -->
    <ul class="nav">
      <li
        routerLinkActive="active"
        *ngFor="let menuitem of menuItems"
        class="nav-item"
      >
        <!--If is a single link-->
        <a
          [routerLink]="[menuitem.path]"
          *ngIf="menuitem.type === 'link' && !menuitem.inMore"
          class="nav-link"
        >
          <i class="material-icons">{{ menuitem.icontype }}</i>
          <p>{{ menuitem.title }}</p>
        </a>

        <!--If it have a submenu-->
        <a
          href="javascript:void(0)"
          id="{{ menuitem.collapse }}-p"
          *ngIf="menuitem.type === 'sub' && !menuitem.inMore"
          (click)="updatePS(); expandOrCollapseMenu(menuitem.collapse)"
          class="nav-link"
          [attr.aria-expanded]="false"
          [attr.aria-controls]="menuitem.collapse"
        >
          <i class="material-icons">{{ menuitem.icontype }}</i>
          <p>
            {{ menuitem.title
            }}
        </a>
        <!-- <p>
          {{ menuitem.title
          }}
        </p> -->


        <!--If is a single link & If it have a submenu--->
        <!-- <a
          [routerLink]="[menuitem.path]"
          href="javascript:void(0)"
          id="{{ menuitem.collapse }}-p"
          *ngIf="menuitem.type === 'linksub' && !menuitem.inMore"
          (click)="updatePS(); expandOrCollapseMenu(menuitem.collapse)"
          class="nav-link"
        >
          <i class="material-icons">{{ menuitem.icontype }}</i>
          <p>{{ menuitem.title }}</p>
        </a> -->

        <!--Display the submenu items-->
        <div
          id="{{ menuitem.collapse }}"
          class="collapse"
          *ngIf="menuitem.type === 'sub' && !menuitem.inMore"
          [attr.aria-labelledby]="menuitem.collapse + '-p'"
        >
          <ul class="nav">
            <li
              routerLinkActive="active"
              *ngFor="let childitem of menuitem.children"
              class="nav-item"
            >
              <a
                [routerLink]="[menuitem.path, childitem.path]"
                class="nav-link"
              >
                <span class="sidebar-mini">{{ childitem.ab }}</span>
                <span class="sidebar-normal">{{ childitem.title }}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>

      <!-- More menu section -->
      <li class="nav-item">
        <a
          class="nav-link"
          href="javascript:void(0)"
          (click)="expandOrCollapseMenu('collapseMore')"
          id="collapseMore-p"
          [attr.aria-expanded]="false"
          aria-controls="collapseMore"
        >
          <i class="material-icons">add</i>
          <p>More<!-- <b class="caret"></b> --></p>
        </a>

        <div
          id="collapseMore"
          class="collapse"
          aria-labelledby="collapseMore-p"
        >
          <ul class="nav">
            <li
              class="nav-item"
              *ngFor="let menuitem of menuItems"
              routerLinkActive="active"
            >
              <!-- Direct link -->
              <a
                *ngIf="menuitem.type === 'link' && menuitem.inMore"
                [routerLink]="[menuitem.path]"
                class="nav-link"
              >
                <i class="material-icons">{{ menuitem.icontype }}</i>
                <p>{{ menuitem.title }}</p>
              </a>

              <!-- Submenu inside More -->
              <a
                *ngIf="menuitem.type === 'sub' && menuitem.inMore"
                class="nav-link"
                href="javascript:void(0)"
                id="{{ menuitem.collapse }}-p"
                (click)="updatePS(); expandOrCollapseMenu(menuitem.collapse)"
                [attr.aria-expanded]="false"
                [attr.aria-controls]="menuitem.collapse"
              >
                <i class="material-icons">{{ menuitem.icontype }}</i>
                <p>
                  {{ menuitem.title }}
                  <!-- <b class="caret"></b> -->
                </p>
              </a>

              <div
                *ngIf="menuitem.type === 'sub' && menuitem.inMore"
                id="{{ menuitem.collapse }}"
                class="collapse"
                [attr.aria-labelledby]="menuitem.collapse + '-p'"
              >
                <ul class="nav">
                  <li
                    class="nav-item"
                    *ngFor="let childitem of menuitem.children"
                    routerLinkActive="active"
                  >
                    <a
                      [routerLink]="[menuitem.path, childitem.path]"
                      class="nav-link"
                    >
                      <span class="sidebar-mini">{{ childitem.ab }}</span>
                      <span class="sidebar-normal">{{ childitem.title }}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</div>
